import commandCenterService from "../services/commandCenter.service";

export const GET_ALL_TILES = "GET_ALL_TILES";
export const ADD_TILE = "ADD_TILE";
export const UPDATE_TILE = "UPDATE_TILE";
export const DELETE_TILE = "DELETE_TILE";

export const getAllTiles = () => dispatch => {
  return commandCenterService
    .getAllTiles()
    .then((response) => {
      const tiles = response?.data ?? [];
      dispatch({
        type: GET_ALL_TILES,
        payload: tiles,
      });
      return Promise.resolve([...tiles]);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const updateTile = (data) => (dispatch) => {
  const payload = {
    CommandCenterTileTypeId: data.commandCenterTileTypeId,
    TileName: data.tileName,
    TileCode: data.tileCode,
    BackgroundColor: data.backgroundColor,
    TextColor: data.textColor
  };

  return commandCenterService.updateTile(payload)
    .then((response) => {
      dispatch({
        type: UPDATE_TILE,
        payload: response.data,
      });
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const addTile = (data) => (dispatch) => {
  const payload = {
    tileName: data.tileName,
    tileCode: data.tileCode,
    backgroundColor: data.backgroundColor,
    textColor: data.textColor
  };

  return commandCenterService.addTile(payload)
    .then((response) => {
      dispatch({
        type: ADD_TILE,
        payload: response.data,
      });
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const deleteTile = (tileId) => dispatch => {
  const payload = {
    CommandCenterTileTypeId: tileId
  };

  return commandCenterService
    .deleteTile(payload)
    .then((response) => {
      dispatch({
        type: DELETE_TILE,
        payload: tileId,
      });
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}; 